// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { Container, Grid } from '@mui/material';
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import * as routes from '../../../routes';
import { BetterLinkUnderline } from './BetterLinkUnderline';

export function AppFooter(): React.ReactElement {
  return (
    <Container
      maxWidth={false}
      component="footer"
      disableGutters={true}
      sx={{ bgcolor: 'primary.main', mt: 'auto', py: 2 }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ color: 'primary.contrastText', px: { xs: 1, md: 3 } }}
      >
        <Grid size={{ xs: 'auto' }} display="flex" gap={2}>
          <BetterLinkUnderline to={routes.PRIVACY}>Privacy Policy</BetterLinkUnderline>
          <BetterLinkUnderline to={routes.TERMS}>Terms of Service</BetterLinkUnderline>
        </Grid>
        <Grid size={{ xs: 'auto' }} display="flex" gap={2}>
          <BetterLinkUnderline to={routes.CONTACT}>Contact Us</BetterLinkUnderline>
          <BetterLinkUnderline to={routes.FEEDBACK} external>
            Feedback
          </BetterLinkUnderline>
          <BetterLinkUnderline to={routes.TUTORIALS}>Tutorials</BetterLinkUnderline>
        </Grid>
      </Grid>
    </Container>
  );
}
